import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { Grid, TextField } from '@material-ui/core';
import cls from '../step7.module.scss';

import CurrencyHelper from '../../../../helpers/Currency';

function Payment({ index, register, errors, formValues, setTicketForm }) {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.locale);

  let totalCurrency = 'EUR';
  if (formValues?.currency) {
    totalCurrency = formValues.currency;
  }

  const { onChange: onChangeValue, ...propsValue } = register(
    `packages.${index}.value`,
    {
      required: t('form.validate.required'),
      min: {
        value: 1,
        message: t('form.validate.maxItem2'),
      },
    },
  );
  return (
    <div className={cls.box_offer}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            type="number"
            error={!!errors?.packages?.[index]?.value}
            label={`${t('create.step7.pricePerPlace')} *`}
            name={`packages.${index}.value`}
            fullWidth
            onChange={(e) => {
              onChangeValue(e);
              setTicketForm({
                packages: formValues?.packages.map((i, ind) =>
                  ind === index ? { ...i, value: +e.target.value } : i,
                ),
              });
            }}
            autoComplete="off"
            variant="outlined"
            {...propsValue}
            helperText={
              errors?.packages?.[index]?.value
                ? errors?.packages?.[index]?.value.message
                : ''
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            InputProps={{
              readOnly: true,
            }}
            value={CurrencyHelper.getFormate(
              formValues?.packages?.[index]?.places &&
                formValues?.packages?.[index]?.value
                ? +formValues?.packages?.[index]?.value /
                    +formValues?.packages?.[index]?.places
                : 0,
              totalCurrency,
              locale.current,
            )}
            error={!!errors?.packages?.[index]?.valuePersone}
            defaultValue={formValues?.packages?.[index]?.valuePersone}
            label={`${t('create.step7.pricePerPlace')} *`}
            name={`packages.${index}.valuePersone`}
            fullWidth
            autoComplete="off"
            variant="filled"
            {...register(`packages.${index}.valuePersone`, {
              required: t('form.validate.required'),
            })}
          />
        </Grid>
      </Grid>
    </div>
  );
}
Payment.propTypes = {
  index: PropTypes.number.isRequired,
  errors: PropTypes.shape({}),
  formValues: PropTypes.shape({}).isRequired,
  setTicketForm: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  control: PropTypes.shape({}).isRequired,
};

Payment.defaultProps = {
  errors: null,
};
export default Payment;
